<template>
  <v-sheet>
    <h2>Challenge Registration</h2>
    <v-data-table
      :headers="headers"
      :items="registrationEvents"
      :items-per-page="5"
      dense
      :loading="loading"
      class="mt-2 elevation-2"
    ></v-data-table>
  </v-sheet>
</template>

<script>
import { CHALLENGE_REGISTRATION_QUERY } from "@/constants/graphql/client/registrations"
import { YYYYMMDD_readable } from "@/lib/fancy_date";

export default {
  name: "ClientChallenges",
  props: ["userId"],
  data() { 
    return {
      loading: true,
      registrationEvents: [],
      challengeRegistrations: {},
      headers: [
        { text: 'Product', value: 'product',},
        { text: 'Challenge', value: 'challenge' },
        { text: 'Nutrition Plan', value: 'nutritionPlan' },
        { text: 'Registration Date', value: 'registrationDate' },
      ],
    }
  },
  methods: {
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
  },
  apollo: {
    challengeRegistrations: {
      query: CHALLENGE_REGISTRATION_QUERY,
      variables() {
        return {
          userId: this.userId
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
          this.registrationEvents = response.data.challengeRegistrations.map((item) => {
            return {
              product: item.product.name,
              challenge: item.challenge !=null ? item.challenge.title : 'No challenge Selected',  
              nutritionPlan: item.nutritionPlan != null ? item.nutritionPlan.name : 'No nutrition plan',
              registrationDate: this.formatDate(item.createdAt)
            } 
          });
        }
      }
    }
  }
}
</script>